import { render, staticRenderFns } from "./link-images.vue?vue&type=template&id=2c997a5d&scoped=true"
import script from "./link-images.vue?vue&type=script&lang=js"
export * from "./link-images.vue?vue&type=script&lang=js"
import style0 from "./link-images.vue?vue&type=style&index=0&id=2c997a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c997a5d",
  null
  
)

export default component.exports